import { funcClientSignupManager } from '@/plugins/axios';


export const postClientSignup = (data, id) => {
  return funcClientSignupManager.post(`api/clientinvites/${id}/onboardingprojects/`, data);
};


export const postIntermediaryClientSignup = (data) => {
  return funcClientSignupManager.post(`intermediary/clientinvite/`, data);
};


